import { render } from "./AgentCard.vue?vue&type=template&id=48b5f3f4&scoped=true"
import script from "./AgentCard.vue?vue&type=script&lang=js"
export * from "./AgentCard.vue?vue&type=script&lang=js"

import "./AgentCard.vue?vue&type=style&index=0&id=48b5f3f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b5f3f4"]])

export default __exports__